<template>
  <ku-dialog :title="$t('批量导入')" :visible.sync="dialogVisible" width="25%" @closed="handleClose" @confirm="uploadDialogConfirm">
    <el-upload
      :action="action"
      :headers="uploadHeaders"
      :data="uploadData"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :limit="1"
      :on-exceed="handleExceed"
      :file-list="fileList"
    >
      <el-button size="small" type="primary">{{ $t('上传模版') }}</el-button>
      <div slot="tip" class="el-upload__tip">
        <div class="text" style="margin-top: 16px">
          {{ $t('为保证数据导入顺利，推荐您使用') }}{{ ' ' }}
          <span class="template-text pointer" @click="downTemplate">{{ $t('标准模版') }}</span>
        </div>
        <div class="text">{{ $t('支持2MB以内的xls、xlsx格式文件') }}</div>
        <div class="text">{{ $t('文件中数据不能超过50000行') }}</div>
      </div>
    </el-upload>
  </ku-dialog>
</template>

<script>
import db from '@klinx/utils/localstorage';
import uploadTemplate from './uploadTemplate';
import { downloadFile } from '@klinx/utils/commons';
import { baseFileApi } from '@klinx/base/src/api/index.js';
export default {
  name: 'UploadPopUp',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    uploadLoading: {
      type: Boolean,
      default: false
    },
    templateName: {
      type: String,
      default: ''
    },
    templateFileName: {
      type: String,
      default: ''
    },
    // 模板是否存储在后台
    isApiSaved: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      action: `${process.env.VUE_APP_BASE_API}/base/attachment/upload`,
      dialogVisible: false,
      fileList: [],
      // 上传的请求头部
      uploadHeaders: {
        token: 'Bearer ' + db.get('TOKEN', '')
      },
      // 上传时附带的额外参数
      uploadData: {
        bizId: 0,
        bizType: 0,
        isSingle: 0,
        id: 0
      },
      fileCollection: {
        serverFile: null,
        uploadFile: null
      },
      card: [],
      workbook: {},
      isDownload: true
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    }
  },
  methods: {
    // 下载模版
    downTemplate() {
      if (this.isApiSaved) {
        if (!this.isDownload) {
          return false;
        }
        baseFileApi.getManageTemplate({ fileName: this.templateFileName }).then((response) => {
          downloadFile(response);
          this.isDownload = false;
          setTimeout(() => {
            this.isDownload = true;
          }, 2000);
        });
        return false;
      }
      require.ensure([], () => {
        const XLSX = require('xlsx');
        const XLSXS = require('xlsx-style');
        const workbook = XLSX.utils.book_new();
        const aoa = uploadTemplate.data[this.templateName];
        const worksheet = XLSX.utils.aoa_to_sheet(aoa);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        if (uploadTemplate.style[this.templateName]) {
          Object.entries(uploadTemplate.style[this.templateName]).forEach((cell) => {
            if (cell[0] === 's') {
              cell[1].forEach((c) => {
                worksheet[c.cell].s = c.style;
              });
            } else {
              worksheet[cell[0]] = cell[1];
            }
          });
        }
        const wopts = {
          bookType: 'xlsx', // 要生成的文件类型
          bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
          type: 'binary'
        };
        const wbout = XLSXS.write(workbook, wopts);
        const blob = new Blob([this.s2ab(wbout)], {
          type: 'application/octet-stream'
        });
        this.openDownloadXLSXDialog(blob, this.templateFileName);
      });
    },
    // 字符串转ArrayBuffer
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },
    openDownloadXLSXDialog(url, saveName) {
      if (typeof url === 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
      }
      const aLink = document.createElement('a');
      aLink.href = url;
      aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
      let event = null;
      if (window.MouseEvent) {
        event = new MouseEvent('click');
      } else {
        event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      }
      aLink.dispatchEvent(event);
    },
    // 保存二进制文件
    beforeUpload(file) {
      // 二进制文件
      this.fileCollection.uploadFile = file;
    },

    // 确认导入
    uploadDialogConfirm() {
      if (!this.fileCollection.uploadFile || this.fileCollection.uploadFile === null) {
        this.$message.info(this.$t('请上传模板！'));
        return false;
      }
      this.$emit('getData', this.fileCollection); // 接收数据
    },

    // 模版导入模块
    handleSuccess(data, file) {
      // 文件传到了服务器的文件信息
      this.fileCollection.serverFile = data.data;
    },

    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.fileCollection.uploadFile = null;
    },

    // 文件超出个数限制时提示
    handleExceed(files, fileList) {
      this.$message.warning(this.$t('一次只能上传一个文件'));
    },

    // 删除前询问
    beforeRemove(file, fileList) {
      return this.$confirm(`${this.$t('确定移除')} ${file.name}？`);
    },

    // 关闭弹窗
    handleClose() {
      this.fileList = [];
      this.fileCollection = {
        serverFile: null,
        uploadFile: null
      };
      this.$emit('close', false);
    }
  }
};
</script>
<style lang="scss" scoped>
.text {
  color: #606266;
  margin-bottom: 8px;
}
.template-text {
  color: $main;
}
</style>
<style lang="scss">
.confirm-btn {
  background-color: $main !important;
  border-color: $main !important;
}
.cancle-btn {
  &:hover {
    color: $main;
    border-color: $main-hover;
    background-color: $main-hover-light;
  }
}
</style>
